"use client";
import { LanguageContext } from "@components/i18n";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import Image from "next/image";
import background from "@assets/svg/eproc_login_bg_img.svg";
import BackgroundImageOne from "@assets/png/eproc_login_project_img.png";
import BackgroundImageTwo from "@assets/svg/people_discuss.svg";
import TripatraLogo from "@assets/png/tripatra_logo.png";
import { ReactNode } from "react";
import { Carousel } from "@mantine/carousel";
import { Card, Text, Box, Image as MantineImage } from "@mantine/core";
import Link from "next/link";
import { useQuery } from "react-query";
import { GetNewsBanner } from "./api";

const BODY_BACKGROUND_STYLE = {
  background: `url(${background.src})`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
};
const TILE_STYLE = { fontSize: "1.5rem", fontWeight: 600 };

const AuthLayout = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation("login");
  const { changeLanguage, language } = useContext(LanguageContext);

  const HandleChangeLanguage = () => {
    const targetLanguage = language === "en" ? "id" : "en";
    changeLanguage(targetLanguage);
  };

  const {
          data: newsList,
      } = useQuery({
          queryKey: [`newsBanner`],
          queryFn: () => GetNewsBanner(),
          enabled: true,
          refetchOnWindowFocus: false,
      });

  return (
    <div
      style={{ display: "flex", height: "100vh", ...BODY_BACKGROUND_STYLE }}
      className="font-open-sans"
    >
      <div className="flex-1 justify-center items-center text-white flex flex-col px-5">
        <div className="relative w-full h-screen ">
          <div className="absolute top-1/2 -translate-y-1/2 z-10">
            <Carousel
              withIndicators
              slideSize="100%"
              slideGap="md"
              styles={{
                indicators: {
                  width: "auto", // ⬅️ penting
                  left: "50%",
                  transform: "translateX(-50%)",
                  gap: 6, // ⬅️ jarak antar dot
                },
                indicator: {
                  width: 12,
                  height: 12,
                  borderRadius: 12,
                },
                control: {
                  // position: "relative",
                  //   bottom: 35,
                  //   top: "auto",
                  //   left: "50%",
                  //   transform: "translateX(-50%)",
                  //   justifyContent: "center",
                  //   gap: 21,
                  width:36,
                  height:36,
                },
              }}
              emblaOptions={{
                loop: true,
                align: "start", // 'start' | 'center' | 'end'
              }}
            >
              {newsList?.map((item, index) => {
                const content = () => {
                  return (
                    <Card
                      radius="md"
                      withBorder
                      className={` ${
                        item.link
                          ? "cursor-pointer hover:shadow-lg transition-shadow duration-300"
                          : ""
                      }`}
                    >
                      <Card.Section
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          height: "94vh", // atur di sini tinggi area gambar (misal 80px, 100px, dll)
                        }}
                      >
                        {/* Gambar */}
                        <MantineImage
                          src={item.image}
                          alt={item.title}
                          h="100%" // tinggi gambar = 100% dari Card.Section
                          w="100%" // tinggi gambar = 100% dari Card.Section
                          fit="cover" // ini yang bikin gambar nge-cover area (crop kalau perlu)
                        />

                        {/* Overlay teks di atas gambar */}
                        <Box
                          style={{
                            position: "absolute",
                            inset: 0, // full area (top/right/bottom/left = 0)
                            zIndex: 2,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                            padding: "16px",
                            // background:
                            //   "linear-gradient(to top, rgba(140,140,140,0.1), rgba(0,0,0,0))",
                          }}
                        >
                        </Box>
                      </Card.Section>
                    </Card>
                  );
                };

                return (
                  <Carousel.Slide key={index}>
                    {item.link ? (
                      <Link
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {content()}
                      </Link>
                    ) : (
                      <>{content()}</>
                    )}
                  </Carousel.Slide>
                );
              })}
            </Carousel>
          </div>
        </div>
      </div>

      <div className="flex flex-col flex-2 justify-center items-center rounded-l-3xl bg-slate-50 min-w-[25vw]">
        <div className="flex-grow flex flex-row p-4 max-h-[10vh] w-full">
          <div>
            <button
              onClick={HandleChangeLanguage}
              className="font-bold uppercase flex-grow float-left text-white p-2 bg-tripatra-9 rounded"
            >
              {language}
            </button>
          </div>
          <div className="ml-auto ">
            <Image
              src={TripatraLogo}
              alt="Tripatra Logo"
              className="mb-2 mr-4 flex-grow"
              style={{ float: "right", maxHeight: "5vw", maxWidth: "5vw" }}
            />
          </div>
        </div>
        <div className="text-center p-4 max-h-[15vh] w-full">
          <p style={TILE_STYLE}>{t("welcomeHero")}</p>
          <p style={TILE_STYLE}>{t("welcomeDesc")}</p>
        </div>

        <div className="flex-grow w-full">{children}</div>
      </div>
    </div>
  );
};

export default AuthLayout;
